export default {
    fade: {
        origin: { opacity: 0 },
        destination: { opacity: 1 },
    },
    "fade-up": {
        origin: { opacity: 0, yPercent: 10 },
        destination: { opacity: 1, yPercent: 0 },
    },
    "fade-left": {
        origin: { opacity: 0, xPercent: 10 },
        destination: { opacity: 1, xPercent: 0 },
    },
    "fade-right": {
        origin: { opacity: 0, xPercent: -10 },
        destination: { opacity: 1, xPercent: 0 },
    },
    "fade-blur": {
        origin: { opacity: 0, filter: "blur(10px)" },
        destination: { opacity: 1, filter: "blur(0px)" },
    },
    "fade-in-up-blur-out": {
        origin: {
            opacity: 0,
            yPercent: 7.5,
            filter: "blur(8px)",
        },
        destination: {
            opacity: 1,
            yPercent: 0,
            filter: "blur(0px)",
        },
    },
    "fade-in-grayscale-out": {
        origin: {
            opacity: 0,
            filter: "grayscale(100%)",
        },
        destination: {
            opacity: 1,
            filter: "grayscale(0%)",
        },
    },
    "fade-in-up-grayscale-out": {
        origin: {
            opacity: 0,
            yPercent: 7.5,
            filter: "grayscale(100%)",
        },
        destination: {
            opacity: 1,
            yPercent: 0,
            filter: "grayscale(0%)",
        },
    },
    "fade-in-sepia-out": {
        origin: {
            opacity: 0,
            filter: "sepia(100%)",
        },
        destination: {
            opacity: 1,
            filter: "sepia(0%)",
        },
    },
    "fade-in-up-sepia-out": {
        origin: {
            opacity: 0,
            yPercent: 7.5,
            filter: "sepia(100%)",
        },
        destination: {
            opacity: 1,
            yPercent: 0,
            filter: "sepia(0%)",
        },
    },
};
